import {
  Outlet, useOutletContext, useParams,
} from 'react-router-dom';
import { RoutingContextType } from '.';
import { CompanyProvider } from '../contexts/company';

export function CompanyRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  const { id } = useParams() as { id: string };

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <CompanyProvider id={id}>
      <Outlet context={contextValue} />
    </CompanyProvider>
  );
}
